<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="User" title="View Users" />
		
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							
							<div class="col-md-12 project-list page-subtitle">
									<div class="row">
										<h4 class="card-title mb-3">Followers of </h4>
										<div class="col-md-2 mt-3 d-flex">
											
											<img :src="$image_url + user.image" class="img-fluid avatar-60 rounded-small float-left" alt="image">
										</div>
										
										<div class="col-md-10 mt-3 d-flex">
											<h6 class=" float-left">
												Name: {{user.name}}<br>
												Phone: {{user.countrycode}} {{user.phone_number}}
											</h6>
										</div>
										
									</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
									<div class="row">
										<div class="col-md-9">
											<label class="d-flex listing-length"><span>Show</span>
												<select class="form-select" v-model="listing_length" @change="fetchFollowers()">
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="20">20</option>
												</select>
												<span>entries</span>
											</label>
										</div>
										<div class="col-md-3">
											<input type="text" class="form-control" placeholder="Search"  v-model="keyword" @keyup="fetchFollowers()"/>
										</div>
									</div>
							</div>
							
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Image</th>	
											<th>Name</th>
											<th>Email & Mobile</th>
											<th>Location</th>
											<th>Lat & Lng</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(users.length)">
										<tr v-for="user in users" :key="user.id">
											<td><img :src="$image_url + user.image" class="img-fluid avatar-60 rounded-small" alt="image"/></td>
											<td>
												{{ user.name }}
											</td>
											<td>{{ user.email }} <br> {{ user.phone_number }}</td>
											<td>{{user.location}}</td>
											<td>
												{{user.latitude}}<br>{{user.longitude}}
											</td>
										</tr>
									</tbody>
									<tbody v-else>
									<tr>
										<td colspan="5" class="text-center">No data</td>
									</tr>
								</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchFollowers(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>	
</template>


<script>
	export default {
		name: "Followers",
		data() {
			return {
				user: {},
				users: [],
				pagination: {},
				edit: false,
				
				keyword: "",
				listing_length: 10,
				token: "",				
			};
		},
		mounted() {},

		created() {
			this.fetchUser();
			this.fetchFollowers();
		},

		methods: {
			fetchUser() {
				this.getToken();
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/users/show?user_id=" + this.$route.params.id, config)
					.then((response) => {
						this.user = response.data.data;
					})
					.catch((err) => console.log(err));
			},
			fetchFollowers(page_url = null) {
				let url = "/api/admin/users/followers?user_id=" + this.$route.params.id + "&limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.users = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			
		},
	};
</script>
